const ROOT = 'APPLICANT_DENY_';

const actions = {
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
} as const;

export default actions;
